import React from 'react';
import {Interpreter, State} from 'xstate';
import {playerMachineId} from '../../machines/appMachine/appMachine';
import {CurrentServiceContext, CurrentStateContext, PlayerServiceContext} from './useCurrentService';

interface IOuter {
  state: State<unknown>;
  service: Interpreter<unknown>;
  children?: React.ReactNode;
}

export const CurrentInterpreterProvider: React.FunctionComponent<IOuter> = ({state, service, children}) => {
  const playerService = service.children.get(playerMachineId);

  return (
    <CurrentStateContext.Provider value={state}>
      <CurrentServiceContext.Provider value={service}>
        <PlayerServiceContext.Provider value={playerService}>{children}</PlayerServiceContext.Provider>
      </CurrentServiceContext.Provider>
    </CurrentStateContext.Provider>
  );
};

CurrentInterpreterProvider.displayName = 'CurrentInterpreterProvider';
